(() => {
  const snapClassPrefix = 'snap-' + 'b2b-new-product-';

  const hide = (selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    });
  };

  const fixProductPrice = () => {
    hide('.product__price-block .price.price--on-sale .price__regular');
    hide('.product__price-block .price.price--on-sale .price__sale s.price-item--regular .' + snapClassPrefix + 'price');
    hide('.product__price-block .price.price--on-sale .price__sale .price-item--sale .' + snapClassPrefix + 'compare-price');

    document.querySelectorAll('.product__price-block .price.price--on-sale .price__sale .' + snapClassPrefix + 'price-container').forEach((element) => {
      element.style.setProperty('margin-right', '0', 'important');
    });
  };

  const start = () => {
    fixProductPrice();
    const priceBlock = document.querySelector('.product__price-block');
    if (priceBlock) {
      new MutationObserver(() => window.requestAnimationFrame(fixProductPrice)).observe(priceBlock, { childList: true, subtree: true });
    }
    [100, 500, 1500, 3000].forEach((delay) => window.setTimeout(fixProductPrice, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
